export { ErrorBoundary, addReactError } from '../domain/error';
export { reactPlugin } from '../domain/reactPlugin';
// eslint-disable-next-line camelcase
export { UNSTABLE_ReactComponentTracker } from '../domain/performance';
//# sourceMappingURL=main.js.map